<!-- 书本详情 -->
<template>
  <div class="books">
    <v-touch v-on:swipeleft="swipeleft" v-on:swiperight="swiperight">
      <div class="books_center">
        <div class="books_top">
        </div>
        <div :style="conheight" class="books_content" id="books_content">
          <div class="bookimg" v-bind:style="{backgroundImage:'url(' + src + ')'}">
            <!-- <el-button style="height:2.5rem" type="info" disabled v-if="num > 0" class="disabled">{{msg}}</el-button> -->
          </div>
        </div>
      </div>
    </v-touch>
    <div style="display: flex;padding: 1rem;">
      <el-button @click="swiperight">上一页</el-button>
      <div class="page">第{{ index + 1 }}页</div>
      <el-button @click="swipeleft" v-if="num < 1">下一页</el-button>
    </div>
    <div style="text-align: center;width:100%">
      <el-button @click="back" type="primary">
        返回
      </el-button>
    </div>
  </div>
</template>

<script>
import * as req from '@/utils/request'
import * as req2 from '@/utils/requestBOOK'

export default {
  data () {
    return {
      // 高度
      conheight: {
        height: ''
      },
      displacement: {
        scale: 1
      },
      isdel: true,
      index: 0,
      pageList: [],
      // 阅读时间
      time: 5000,
      num: 0,
      addTime: 5,
      // 本书的阅读记录
      readPage: [],
      msgOne: false
      // src: 'https://ss0.baidu.com/94o3dSag_xI4khGko9WTAnF6hhy/exp/w=500/sign=1303619e7df0f736d8fe4c013a54b382/b999a9014c086e06a5f268aa07087bf40bd1cbfd.jpg'
    }
  },
  computed: {
    bookType: function () {
      return this.$route.query.books.type
    },
    bookId: function () {
      return this.$route.query.books.id
    },
    fileName: function () {
      return this.$route.query.books.file_name
    },
    msg: function () {
      if (this.num > 0) {
        return this.num + '秒后可看下一页'
      }
    },
    // 获取当前页码图片链接
    src: {
      get () {
        let index = this.index
        if (this.pageList.length < 1) {
          return ''
        }
        if (this.pageList.length < index) {
          index = 1
        }
        let booksUrl = this.gmdss.bookUrl
        // let fileName = this.fileName
        return booksUrl + this.bookId + '/' + this.pageList[index].path
        // return booksUrl + this.bookId + '/' + fileName + '/' + this.pageList[index].path
      },
      set (v) {
        return v
      }
    }
  },
  created () {
    window.addEventListener('resize', this.getHeight)
    this.getHeight()
  },
  mounted () {
    // this.getBooks()
  },
  // 路由进来前
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getBooks()
    })
  },
  // 路由跳出后
  beforeRouteLeave (to, from, next) {
    this.stopCountDown()
    this.int = 0
    this.index = 0
    this.src = ''
    this.pageList = []
    this.isdel = true
    this.msgOne = false
    next()
  },
  watch: {
    index: function (newVal, oldVal) {
      this.index = newVal
    }
  },
  methods: {
    getHeight () {
      this.conheight.height = window.innerHeight - 160 + 'px'
    },
    back () {
      this.stopCountDown()
      this.int = 0
      this.index = 0
      this.src = ''
      this.pageList = []
      this.$router.push('/index')
    },
    getDistance (start, stop) {
      // Math.hypot()计算参数的平方根
      return Math.hypot(stop.x - start.x, stop.y - start.y)
    },
    // 上一页
    swiperight () {
      this.msgOne = false
      this.stopCountDown()
      document.getElementById('books_content').scrollTop = 0
      clearInterval(this.int)
      if (this.index === 0) {
        this.$message.error('已经是第一页')
        return
      }
      this.index--
    },
    // 下一页
    swipeleft () {
      if (this.num > 0) {
        return
      }
      document.getElementById('books_content').scrollTop = 0
      if (this.index >= this.pageList.length - 1) {
        if (this.msgOne === false) {
          this.$message.error('已经是最后一页')
          this.msgOne = true
          this.countDown()
        }
        return
      }
      this.index++
      this.recordBook()
    },
    // 倒计时
    countDown () {
      let res = this.gmdss.getIsRead(this.bookId)
      // 已经读完的话, 就不用倒计时
      if (res && res.isOver) {
        this.num = 0
        return
      }
      this.stopCountDown()
      this.num = 0
      let _this = this
      this.int = setInterval(function () {
        _this.clock()
      }, 1000)
    },
    clock () {
      if (this.num > 0) {
        this.num--
        // return
      }
      if (this.num === 0) {
        this.stopCountDown()
        this.recordBook()
      }
    },
    // 记录读书
    recordBook () {
      let studyRecordStr = this.gmdss.user_info.study_record
      let studyRecord = this.gmdss.stringToJson(studyRecordStr)
      let id = this.bookId
      let obj = {}
      if (this.index >= this.pageList.length - 1) {
        obj.isOver = true
      }
      obj.index = this.index
      obj.type = this.bookType
      studyRecord[id] = obj
      let updateData = {
        id: id,
        data: obj
      }
      let record = JSON.stringify(studyRecord)
      this.recordFinish(record, updateData)
    },
    // 停止倒计时
    stopCountDown () {
      clearInterval(this.int)
      this.int = 0
      this.num = 0
    },
    // 更新学习记录和学习时长
    recordFinish (record, updateData) {
      // let beforeTime = this.gmdss.user_info.learn_time
      // let learnTime = this.addTime + beforeTime
      // 更新本地的学习时长
      // this.gmdss.user_info.learn_time = learnTime
      // 本地学习记录
      // this.gmdss.user_info.study_record = record

      let msg = {}
      msg.id = this.gmdss.user_info.id
      let data = {}
      // data.study_record = record
      // 将当前书本数据发送到后端判断是否更新
      data.updateData = updateData
      // data.learn_time = learnTime
      data.addTime = 5
      msg.data = data
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.recordFinishfn
      sendData.vm = this
      req.Post('user/eidt_User', sendData)
    },
    // todo 在这边重新拉取一遍学习书本数据
    recordFinishfn (data) {
      if (data === null) {
        this.$message('服务器未连接')
        return
      }
      if (data.err_code !== 0) {
        this.$message(data.err_msg)
      }
    },
    // close () {
    //   this.$message(this.$route.query.file)
    //   this.stopCountDown()
    //   this.int = 0
    //   this.$router.push({path: '/index/menuIndex'})
    // },
    // 获取书本数据
    getBooks () {
      let book = this.$route.query.books
      if (book.id === undefined) {
        this.$router.push({path: './'})
        return
      }
      let msg = {}
      msg.id = book.id
      msg.file_name = book.file_name
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.getBooksfn
      sendData.vm = this
      // req.Post('fileMenuData/get_book', sendData)
      req2.Post('fileMenuData/get_book', sendData)
    },
    getBooksfn (data) {
      let bookId1 = this.bookId
      if (data === null) {
        this.$message('服务器未连接')
        return
      }
      if (data.err_code !== 0) {
        this.$message(data.err_msg)
        return
      }
      let page = data.list
      let list = page.page_list
      this.pageList = list
      let res = this.gmdss.getIsRead(bookId1)
      if (res && res.index && !res.isOver) {
        this.index = res.index + 1
      }
      if (list.length > 0) {
        this.countDown()
      }
    }
  }
}
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>
.bookimg {
  display: flex;
  justify-content: center;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
}

.books {
  width: 100%;
  /* display: flex; */
}

.page {
  width: 100%;
  text-align: center;
}

.books_top {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/books.vue